/**
 * 处理页码切换相应交互
 * 查询列表数据统一命名为 $_getDataList()
 */
export default {
  data() {
    return {
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
      },
    };
  },
  methods: {
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getDataList && this.$_getDataList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getDataList && this.$_getDataList();
    },
  },
};
